"use strict"

export default class LongTouch {
  /**
   * 构造器
   * @param map 地图对象
   * @param layerId 图层id
   * @param callback 长按回调函数
   */
  constructor(map,layerId,callback,timeValue=1000) {
    this.timeValue=timeValue;//长按时间阈值
    this.layerId=layerId;
    this.map=map;
    this.callback=callback;


    this.startEvent=(e)=>{
      this._clearTimer();
      let data = e.features[0];
      this.timer=setTimeout((e)=>{
        if(this.callback){
          this.callback(data)
        }
      },this.timeValue)
    };
    this.map.on("touchstart", this.layerId, this.startEvent);


    this.stopEvent=(e)=>{
      this._clearTimer();
    };


    this.map.on("touchmove", this.layerId, this.stopEvent);
    this.map.on("touchend",  this.layerId, this.stopEvent);
  }

  /**
   * 清理计时器
   * @private
   */
  _clearTimer(){
    if(this.timer){
      clearTimeout(this.timer);
      this.timer=null;
    }
  }

  /**
   * 移除长按事件
   */
  close(){
    this._clearTimer();
    this.map.off("touchstart", this.layerId, this.startEvent);
    this.map.off("touchmove", this.layerId, this.stopEvent);
    this.map.off("touchend",  this.layerId, this.stopEvent);
  }
}



// WEBPACK FOOTER //
// ./src/tool/longTouch/LongTouch.js